import React, { useEffect, useState } from 'react'

// react meta tags
import { ReactTitle } from 'react-meta-tags';

// react redux
import { connect } from "react-redux";

// actions
import { setGlobalLoading } from 'redux/actions/actionCommon';

// api
import { validatePaymentApi } from 'utlis/Apis/Orders_API';

// react toastify
import { toast } from "react-toastify";

// APIs | cart
import {
    getCartItems,
    checkCoupon,
    chargeOrderPaymentApi,
} from "utlis/Apis/Cart_API";

// themes
import Theme1 from './Themes/CompletePaymentTheme1/CompletePayment'

// app messages
import {
    ERROR_WHILE__NAME,
    UNKNOWN_ERROR_OCCURED,
} from "utlis/AppMessages/AppMessages";


// styles
import MainSectionStyles from './Themes/styles/MainSectionStyles'

// icons
import { AiOutlineWarning } from "react-icons/ai";


function CompletePayment(props) {
    // props
    const {
        globalLoading,
        globalAppTheme,

        match,

        setGlobalLoading
    } = props

    // states
    const [isRequestValid, setIsRequestValid] = useState(false)

    const [allCheckoutDetails, setAllCheckoutDetails] = useState({})

    const [cartDetails, setCartDetails] = useState(null)
    const [cartItems, setCartItems] = useState([])
    const [cartImages, setCartImages] = useState(null)

    const [userShippingAddress, setUserShippingAddress] = useState(null)
    const [userBillingAddress, setUserBillingAddress] = useState(null)

    const [orderIdFromUrl, setOrderIdFromUrl] = useState("")
    const [orderTokenFromUrl, setOrderTokenFromUrl] = useState("")

    const [pageCoupon, setPageCoupon] = useState("");
    const [pageCouponBtnLoading, setPageCouponBtnLoading] = useState(false);
    const [pageCouponBtnDisabled, setPageCouponBtnDisabled] = useState(false);

    const [errorMessage, setErrorMessage] = useState("");

    // function to remove header and footer
    const removeHeaderAndFooter = () => {
        const header = document.querySelector(".app-root-layout > header")
        const footer = document.querySelector(".app-root-layout > .footer-container")

        if (header !== null && footer !== null) { // if header and footer exist, removing header and footer
            setTimeout(() => {
                header.remove()
                footer.remove()
            }, 200);
        }
    }

    // checking if reset password details are valid
    useEffect(() => {
        if (match?.params?.orderId && match?.params?.orderToken) {

            setOrderIdFromUrl(match.params.orderId) // setting details
            setOrderTokenFromUrl(match.params.orderToken)  // setting details

            // global loading
            setGlobalLoading(true)

            const dataToValidate = {
                _order_id: match.params.orderId,
                _order_token: match.params.orderToken
            }

            // validating user details
            validatePaymentApi(dataToValidate).then(res => {
                // remove header and footer
                removeHeaderAndFooter()

                // global loading
                setGlobalLoading(false)

                const resData = res.data

                console.log("resData ", resData)

                if (resData?.success) {  // if link is valid
                    setIsRequestValid(true)

                    setCartDetails(resData.order) // setting cart details
                    setCartImages(resData.images) // setting cart images
                    setCartItems(resData.order_items) // setting cart items
                }

                if (resData?.error) {  // if link is inValid
                    setErrorMessage(resData?.message ?? "Unauthorized Access") // setting error message

                    setIsRequestValid(false)

                    // dismissing all the previous toasts first
                    // toast.dismiss();

                    // // showing the error message
                    // toast.info(resData?.message ?? "Unauthorized Access", {
                    //     autoClose: 2500,
                    //     onClose: () => { },
                    // });
                }
            }).catch(err => {
                console.log("errr ", err);

                // remove header and footer
                removeHeaderAndFooter()

                // global loading
                setGlobalLoading(false)
            })
        }
    }, [])

    // calling create order function if all the required data is available
    useEffect(() => {
        if (
            allCheckoutDetails?.billingAddressDetails &&
            allCheckoutDetails?.shippingAddressDetails &&
            allCheckoutDetails?.shippingMethod &&
            allCheckoutDetails?.stripe_token
        ) { // if billng details exist then calling the
            setTimeout(() => {
                handleCreateOrder()
            }, 200);
        }
    }, [allCheckoutDetails])

    // create order
    const handleCreateOrder = () => {
        if (allCheckoutDetails) {
            // enabling page loading
            setGlobalLoading(true)

            // data required
            const requiredData = {
                order_id: orderIdFromUrl,
                stripe_token: allCheckoutDetails?.stripe_token,
                shipping_person: {
                    address_type: "Shipping",
                    ...allCheckoutDetails?.shippingAddressDetails
                },
                billing_person: {
                    address_type: "Billing",
                    ...allCheckoutDetails?.billingAddressDetails
                },
            }

            // network request
            chargeOrderPaymentApi(requiredData).then(res => {
                const resData = res.data

                // global loading
                setGlobalLoading(false)

                // if success
                if (resData.success) {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.success(resData.message, {
                        autoClose: 2500,
                        onClose: () => {
                            // window.location.reload() // reloading the windows
                        }
                    });
                }

                // if error
                if (resData.error) {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(resData?.message ?? UNKNOWN_ERROR_OCCURED, {
                        autoClose: 2500
                    });
                }

            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} chargeOrderPaymentApi `, err.message);

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        // global loading
                        setGlobalLoading(false)
                    },
                });
            })

        }
    }

    // coupon value change
    const handleCouponValueChange = (ev) => {
        const inpVal = ev.target.value
        if (inpVal) {
            setPageCoupon(inpVal)
        } else {
            setPageCoupon("")
        }
    }

    // apply coupon click
    const handleApplyCouponClick = (ev) => {
        ev.preventDefault()

        // if (pageCoupon?.length) {
        //     // button loading
        //     setPageCouponBtnLoading(true)
        //     setPageCouponBtnDisabled(true)

        //     const requiredData = {
        //         tempOrderId,
        //         couponCode: pageCoupon,
        //         customerId: currentUser?.userId ?? '',
        //     }

        //     checkCoupon(commonToken ?? "", requiredData).then(res => {
        //         const resData = res.data

        //         // if success
        //         if (resData?.success) {

        //         }

        //         // if error
        //         if (resData?.error) {
        //             // dismissing all the previous toasts first
        //             toast.dismiss();

        //             // showing the error message
        //             toast.error(resData?.message || "invalid coupon", {
        //                 autoClose: 2500,
        //                 onClose: () => {
        //                     // button loading
        //                     setPageCouponBtnLoading(false)
        //                     setPageCouponBtnDisabled(false)
        //                 },
        //             });

        //         }
        //     }).catch(err => {
        //         console.log(`${ERROR_WHILE__NAME} checkCoupon `, err.message);

        //         // dismissing all the previous toasts first
        //         toast.dismiss();

        //         // showing the error message
        //         toast.error(UNKNOWN_ERROR_OCCURED, {
        //             autoClose: 2500,
        //             onClose: () => {
        //                 // button loading
        //                 setPageCouponBtnLoading(false)
        //                 setPageCouponBtnDisabled(false)
        //             },
        //         });
        //     })
        // }
    }

    return (
        <MainSectionStyles>
            {/* website title */}
            <ReactTitle title={"Complete Order | Ruhlistic Decor"} />

            {
                (isRequestValid) ? (
                    <React.Fragment>
                        {
                            globalAppTheme === 'theme1' ? (
                                <Theme1
                                    currentOrderId={orderIdFromUrl}

                                    allCheckoutDetails={allCheckoutDetails}
                                    setAllCheckoutDetails={setAllCheckoutDetails}

                                    cartDetails={cartDetails}
                                    cartItems={cartItems}
                                    cartImages={cartImages}

                                    userBillingAddress={userBillingAddress}
                                    userShippingAddress={userShippingAddress}

                                    pageCoupon={pageCoupon}
                                    handleCouponValueChange={handleCouponValueChange}
                                    pageCouponBtnLoading={pageCouponBtnLoading}
                                    pageCouponBtnDisabled={pageCouponBtnDisabled}
                                    handleApplyCouponClick={handleApplyCouponClick}
                                />
                            ) : null
                        }
                    </React.Fragment>
                ) : (
                    <>
                        {
                            !globalLoading ? (
                                <div className="error-occured d-flex align-items-center justify-content-center">
                                    <div className="inner d-flex align-items-center justify-content-center">
                                        <div className="content w-100 text-center">
                                            <div className="icon mb-2 text-danger">
                                                <AiOutlineWarning />
                                            </div>
                                            <p className="head st-fw-600 st-fs-17 mb-2">Error Occured</p>
                                            <p className="desc mb-0">
                                                {errorMessage}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ) : null
                        }
                    </>
                )
            }
        </MainSectionStyles>
    )
}


const getDataFromStore = (state) => {
    return {
        globalAppTheme: state.common.globalAppTheme,
        globalLoading: state.common.globalLoading,
    };
};

const dispatchActionsToProps = (dispatch) => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    };
};

export default connect(getDataFromStore, dispatchActionsToProps)(CompletePayment);